import { all } from 'redux-saga/effects';
import * as curriculumListSaga from './containers/curriculum-list/saga';
import * as masterCoursesSaga from './containers/master-courses/saga';
import * as curriculumDocumentsSaga from './containers/curriculum-documents/saga';

function* mainSaga() {
    yield all([
        curriculumListSaga.getCountriesSaga(),
        curriculumListSaga.getDocumentsByPublicationSaga(),
        curriculumListSaga.getSectionsByDocumentSaga(),
        curriculumListSaga.getStatesByCountrySaga(),
        curriculumListSaga.getSectionDetailsSaga(),
        curriculumListSaga.registerMasterCourseSaga(),
        curriculumListSaga.getPublicationsSaga(),
        masterCoursesSaga.getMasterCoursesByCountrySaga(),
        masterCoursesSaga.getCountriesWithMasterCoursesSaga(),
        masterCoursesSaga.getSubjectsSaga(),
        masterCoursesSaga.getMasterCoursesSaga(),
        curriculumDocumentsSaga.getSectionFileSaga(),
        curriculumDocumentsSaga.checkSectionFileSaga(),
        curriculumDocumentsSaga.deleteSectionFileSaga(),
        curriculumDocumentsSaga.uploadSectionFileSaga()
    ]);
}

export default mainSaga;



// WEBPACK FOOTER //
// ./app/main-saga.js